import type { TriggerInstanceNanoId } from '@composio/types'
import { toast } from 'react-hot-toast'

import { env } from '~/env'
import {
  deleteTriggerInstancesManageByTriggerId,
  getOrgProjectTrigger,
  getTriggersTypes,
  getTriggersTypesBySlug,
  patchOrgProjectTrigger,
  patchTriggerInstancesManageByTriggerId,
  postPaymentsManageSubscription,
  postPaymentsSession,
  postToolsExecuteByToolSlugInput,
} from '~/generated/client'

export const changeTriggerStatus = ({
  triggerId,
  enabled,
}: {
  triggerId: TriggerInstanceNanoId
  enabled: boolean
}) => {
  return patchTriggerInstancesManageByTriggerId({
    requestBody: {
      status: enabled ? 'enable' : 'disable',
    },
    triggerId,
  })
}

export const getTriggerTypes = ({
  slug,
  page = 1,
  // authConfigId,
  // connectedAccountIds,
}: {
  slug?: string
  page?: number
  // authConfigId?: AuthConfigNanoId;
  // connectedAccountIds?: string;
}) => {
  return getTriggersTypes({
    cursor: page ? `${page}` : undefined,
    limit: 1000,
    toolkitSlugs: slug ? [slug] : [], // Ensure toolkitSlugs is an array
  })
}

export const deleteTriggerInstance = (triggerId: TriggerInstanceNanoId) => {
  return deleteTriggerInstancesManageByTriggerId({
    triggerId,
  })
}
export const getCLICodeInExchangeForApp = async ({ key }: { key: string }) => {
  const apiUrl = `${env.NEXT_PUBLIC_V3_API_URL}/api/v1/cli/get-cli-code?key=${key}`

  const response = await fetch(apiUrl, {
    method: 'GET',
    credentials: 'include',
    headers: {
      'Content-Type': 'application/json',
      'X-Project-Id':
        (window as unknown as { projectId: string }).projectId ||
        localStorage.getItem('current.project') ||
        '',
    },
  })

  const data = await response.json()
  return data as { cliCode: string }
}

export const toggleTriggerEnabled = (enabled: boolean) => {
  return patchOrgProjectTrigger({
    enabled,
  })
}

export const getGlobalTriggerState = () => {
  return getOrgProjectTrigger()
}

export const getTriggerInfo = (triggerName: string) => {
  return getTriggersTypesBySlug({
    slug: triggerName,
  })
}

export const createCheckoutSession = (payload: {
  plan: string
  applyDiscount: boolean
}) => {
  return postPaymentsSession({
    requestBody: {
      plan: payload.plan as 'HOBBY' | 'STARTER' | 'GROWTH',
      applyDiscount: payload.applyDiscount,
    },
  })
}

export const createSelfServePortalSession = () => {
  return postPaymentsManageSubscription()
}

export const getTopEntities = (query = '') => {
  toast.error('migrate to getTopEntities')
}

export const getExampleActionInput = (actionName: string, input: string) => {
  return postToolsExecuteByToolSlugInput({
    toolSlug: actionName,
    requestBody: {
      text: input,
    },
  })
}
